"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CentMethods = void 0;
var CentMethods;
(function (CentMethods) {
    CentMethods["Publish"] = "publish";
    CentMethods["Broadcast"] = "broadcast";
    CentMethods["Subscribe"] = "subscribe";
    CentMethods["Unsubscribe"] = "unsubscribe";
    CentMethods["Disconnect"] = "disconnect";
    CentMethods["Refresh"] = "refresh";
    CentMethods["Presence"] = "presence";
    CentMethods["PresenceStats"] = "presence_stats";
    CentMethods["History"] = "history";
    CentMethods["HistoryRemove"] = "history_remove";
    CentMethods["Channels"] = "channels";
    CentMethods["Info"] = "info";
})(CentMethods = exports.CentMethods || (exports.CentMethods = {}));
